// extracted by mini-css-extract-plugin
export var root = "Images-module--root--1pXsD";
export var images = "Images-module--images--1EQLZ";
export var singleImage = "Images-module--singleImage--LjCnk";
export var carouselContainer = "Images-module--carouselContainer--1UrHb";
export var arrowContainer = "Images-module--arrowContainer--1kdLe";
export var arrowLeft = "Images-module--arrowLeft--1pjcZ";
export var arrowRight = "Images-module--arrowRight--3xMzw";
export var clickable = "Images-module--clickable--2MqPJ";
export var railContainer = "Images-module--railContainer--2nZbG";
export var rail = "Images-module--rail--2iWQw";
export var slide = "Images-module--slide--1fXC7";
export var image = "Images-module--image--oWF60";
export var dots = "Images-module--dots--2th7j";
export var selected = "Images-module--selected--3388e";
export var spacing = "Images-module--spacing--1bVuB";
export var middle = "Images-module--middle--2ZK8V";